module.exports = __webpack_public_path__ + "assets/img/extractionTarot_Tit.bfd790a9.png";